module.exports = __webpack_public_path__ + "img/sample-2.070128f.webp";